import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import {
  readStoredDailyAccessDate,
  saoPauloDateKey,
  storeDailyAccessDate,
  usageHeatmapRepository,
} from "../repositories/usageHeatmapRepository";
import { usageHeatmapQueryKey } from "./useUsageHeatmapQuery";

/** Records one app open per São Paulo day for the signed-in session. */
export const useRecordDailyAccess = (enabled: boolean) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!enabled) return;

    const today = saoPauloDateKey(new Date());
    if (readStoredDailyAccessDate() === today) return;

    usageHeatmapRepository
      .recordDailyAccess()
      .then((result) => {
        storeDailyAccessDate(result.accessDate);
        if (result.created) {
          void queryClient.invalidateQueries({ queryKey: usageHeatmapQueryKey });
        }
      })
      .catch(() => {
        // Leave the day unmarked so a later visit can retry.
      });
  }, [enabled, queryClient]);
};
